
import { paymentService } from '../../services/paymentService';
import { Payment } from '../../types/Payment';
import useDataById from '../core/useDataById';

export  function usePayment({ id }: { id: string }) {
    const {
        data: payment,
        loading,
        error,
        deleteItem,
        updateItem
    } = useDataById<Payment>({ service: {
        ...paymentService,
        ...paymentService.baseService
    }, id });

    return {
     payment,
     error,
     loading,
     deletePayment: deleteItem,
     updatePayment: updateItem,
    }

}
